"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormFacadeButtonGhost", {
    enumerable: true,
    get: function() {
        return FormFacadeButtonGhost;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _ri = require("react-icons/ri");
const _AdminButton = require("../../Button/AdminButton");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormFacadeButtonGhost = (param)=>{
    let { className, size, placeholder } = param;
    return /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        className: "".concat(className, " text-uppercase"),
        type: "button",
        variant: "ghost",
        size: size === "large" ? "lg" : "sm"
    }, placeholder, " ", /*#__PURE__*/ _react.default.createElement(_ri.RiArrowDownSLine, {
        size: 16
    }));
};

//# sourceMappingURL=FormFacadeButtonGhost.js.map